import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {

  transform(items: any[], key: string, disabled: boolean, ...args: any[]): any {
    if (!items || !key || disabled) {
      return items;
    }

    const grouped = items.reduce((rv, x) => {
      (rv[this.accessMember(x, key)] = rv[this.accessMember(x, key)] || []).push(x);
      return rv;
    }, {});

    return Object.values(grouped).flat();
  }

   accessMember(obj: any, path: string): any {
    const parts = path.split(".");
    if (parts.length == 1) {
      return obj[parts[0]];
    }
    return this.accessMember(obj[parts[0]], parts.slice(1).join("."));
  }

}
